import type { BodyRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type CreateTelehealthRequestVisitRequestBody =
  paths['/event-requests/telehealth-visit-requests']['post']['requestBody']['content']['application/json'];

type CreateTelehealthRequestVisitResponse =
  paths['/event-requests/telehealth-visit-requests']['post']['responses']['201']['content']['application/json'];

export const createTelehealthRequestVisit = async ({ body }: BodyRequest<CreateTelehealthRequestVisitRequestBody>) =>
  nodeApiClient.post<CreateTelehealthRequestVisitResponse, ApiClientResponse<CreateTelehealthRequestVisitResponse>>(
    nodeApiRoutes.telehealthVisits.createRequest,
    body,
  );
